import { BannerData } from "../../models/types";

export const allImagesPath = {
  logo: "/images/home/Obscura_White_Logo2.png",
  leftEllips: "/images/home/banner_left_ellips.png",
  rightEllips: "/images/home/banner_right_ellips.png",
  featureProductImg: "/images/home/feature_product_fg_image.png",
  featureProductImg2: "/images/home/feature_product_fg_image2.png",
  orderGuideVideo: "/videos/home-page-movie-v5.mp4",
  homevisual: "/images/home/homevisual.png",
  jumpingMen: "/images/home/jumping_man_img.png",
  storyVideo: "./videos/gitar-banner-video.mp4",
  mapImage: "/images/home/map.png",
  signupImg: "/images/home/signup-img.png",
  loginImg: "/images/home/login-img.png",
  forgotImg: "/images/home/forgot-password-img.png",
  regOtpImg: "/images/home/otp-img.png",
  signLellips: "/images/home/signup-left-ellips.png",
  serviceImage: "./images/services/service-img.png",
  rocketIcon: "./images/services/rocket.png",
  drillService: "./images/services/first-service-img.png",
  powderCoatingService: "./images/services/second-service-img.png",
  uvPrintingService: "./images/services/third-service-img.png",
  customProductStepImage: "/images/services/custom-product-steps.png",
  drillingCustomBannerImg: "/images/services/drilling-custom-banner-img.png",
  drillingPageStepsImg: "/images/services/drill/drilling-page-steps-img.png",
  powderCoatingPageStepsImg: "/images/services/powder-coating-page-steps-img.png",





  // new images added
  // home orderSection Image
  homeOrderSection: "/images/obscura_images/FINISHED_PEDAL.jpg",

  // Service Page 
  serviceSection: "/images/obscura_images/CUSTOMSERVICES.jpg",

  serviceCustomizationDrilling: "/images/obscura_images/DRILLING.jpg",
  serviceCustomizationDrillingSub: "/images/obscura_images/CUTTINGTOOLS.jpg",
  serviceCustomDrilling: "/images/obscura_images/END_MILLS.png",
  serviceCustomPowder: "/images/obscura_images/COATEDENCLOSURES.jpg",



  serviceCustomizationPowder: "/images/obscura_images/POWDERCOATING.jpg",
  serviceCustomizationPrint: "/images/obscura_images/UV_PRINT.jpg",
  serviceCustomizationPrintSub: "/images/obscura_images/UV_PRINT_3.jpg",
  serviceCustomizationPrintSub4: "/images/obscura_images/UV_Print_4.png",





  exampleTestimonials: "/images/obscura_images/STEVE_REIS.jpg",













  //visuals data for services
  drilVisual: "/images/services/drill/drillvisual.png",
  powderVisual: "/images/services/powdercoating/powdervisual.png",
  uvPrintingVisual: "/images/services/uvprinting/uvvisual.png",

  //drillServiceImages
  enclosure1: "/images/services/drill//enclosure-service-1.png",
  enclosure2: "/images/services/drill//enclosure-service-2.png",
  enclosure3: "/images/services/drill//enclosure-service-3.png",
  enclosure4: "/images/services/drill//enclosure-service-4.png",
  CustomDrillingMachineImg: "/images/services/custom-drilling-machine-img.png",

  //powdercoatingItems
  whyPowderImg: "/images/services/powdercoating/whypowder.png",
  steelImg: "/images/services/powdercoating/steel.png",
  brassImg: "/images/services/powdercoating/brass.png",
  otherImg: "/images/services/powdercoating/other.png",
  guitarImg: "/images/services/powdercoating/guitar.png",
  coatingMachineImg: "/images/services/powdercoating/coatingmachine.png",
  //uvprintingItems
  whyuvImg: "/images/services/uvprinting/yuv.png",
  glassImg: "/images/services/uvprinting/glass.png",
  plasticImg: "/images/services/uvprinting/plastics.png",
  metalImg: "/images/services/uvprinting/metals.png",
  woodImg: "/images/services/uvprinting/woods.png",
  uvPrintingMachineImg: "/images/services/uvprinting/uvmachine.png",

  //color selection
  prismaticpowerImg: "/images/products/colorbrand1.png",

  //examples
  // example1: "/images/examples/cardImage1.png",
  // example2: "/images/examples/cardImage2.png",
  // example3: "/images/examples/cardImage3.png",
  // example4: "/images/examples/cardImage4.png",
  // example5: "/images/examples/cardImage5.png",
  // example6: "/images/examples/cardImage6.png",
  example1: "/images/examples/cardImages/cardImage1.jpg",
  example2: "/images/examples/cardImages/cardImage2.jpg",
  example3: "/images/examples/cardImages/cardImage3.jpg",
  example4: "/images/examples/cardImages/cardImage4.jpg",
  example5: "/images/examples/cardImages/cardImage5.jpg",
  example6: "/images/examples/cardImages/cardImage6.jpg",
  example7: "/images/examples/cardImages/cardImage7.jpg",
  example8: "/images/examples/cardImages/cardImage8.jpg",
  example9: "/images/examples/cardImages/cardImage9.jpg",
  userProfile: "/images/examples/userProfile.png",
  userImage: "/images/examples/userImage.png",

  //privacy policy
  privacyPolicyImg: "/images/lock.png",

  //terms and conditions
  termsAndConditons: "/images/terms_conditions.png",
};

export const allVideoPath = {
  orderGuideVideo: "/videos/home-page-movie-v5.mp4",
  storyVideo: "./videos/gitar-banner-video.mp4",
};

export const navigationData = [
  { text: "Home", link: "/" },
  { text: "Products", link: "/products" },
  { text: "Services", link: "/services" },
  { text: "Resources", link: "/resources" },
  { text: "Examples", link: "/examples" },
  { text: "About Us", link: "/about-us" },
  { text: "Contact Us", link: "/contact-us" },
];

export const footerData = [
  {
    heading: "Social",
    points: ["Facebook", "Instagram", "YouTube"],
    icons: [
      "/images/home/message.png",
      "/images/home/location.png",
      "/images/home/phone.png",
      "/images/home/clock.png",
    ],
  },
  {
    heading: "Menu",
    points: [
      "Home",
      "Products",
      "Services",
      "Resources",
      "Examples",
      "About Us",
      "Contact Us",
    ],
    links: [
      "/",
      "/products",
      "/services",
      "/resources",
      "/examples",
      "/about-us",
      "/contact-us",
    ],

  },
  {
    heading: "Say Hello",
    points: [
      "contact@obscuramfg.com",
      "712 Olive ave SW, Lenoir NC,28645",
      "828-214-5250",
      "M-F 9-5",
    ],
    icons: [
      "/images/home/message.png",
      "/images/home/location.png",
      "/images/home/phone.png",
      "/images/home/clock.png",
    ],
    iconLinks: [
      "mailto:contact@obscuramfg.com",
      "https://www.google.com/maps?q=712+Olive+ave+SW,+Lenoir+NC,+28645",
      "tel:8282145250",
      "#",
    ],
    isIcon: true,
  },
];

export const featuredProductsData = [
  {
    imgUrl: allImagesPath.featureProductImg,
    alt: "Guitar pickguard",
    heading: "Guitar Pickguards",
    btnText: "Shop Now",
  },
  {
    imgUrl: allImagesPath.featureProductImg2,
    alt: "Guitar knobs",
    heading: "Guitar Knobs",
    btnText: "Shop Now",
  },
];

export const shopNowProductsData = [
  {
    id: "67cb7ca991fb8a62d2e6c7d1",
    name: "Bass Vi Double Bridge Humbucker Conversion Pickguard",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 500,
    salesPrice: 450,
    stock: 12,
    sold: 0,
    rating: 5,
    sku: "GUI-GUIKN-012-C7D1",
    quantity: 0,
    discount: 0,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "latest", // Added sorting key
    featuredImage: "/images/products/guitar.png",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f7",
      name: "Guitar",
      slug: "guitar",
    },
    tags: ["guitar", "knob"],
  },

  {
    id: "67cb7ca991fb8a62d2e6c7d8",
    name: "Electric Guitar",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 1500,
    salesPrice: 1300,
    stock: 5,
    sold: 2,
    rating: 4.9,
    sku: "GUI-ELEC-005-C7D8",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "highest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
    images: [
      "https://www.gearank.com/wp-content/uploads/files/field/image/electric-guitar-knobs_0.jpg",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f7",
      name: "Guitar",
      slug: "guitar",
    },
    tags: ["guitar", "electric"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7d9",
    name: "Guitar Amplifier",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 800,
    salesPrice: 700,
    stock: 8,
    sold: 4,
    rating: 4.8,
    sku: "GUI-AMP-008-C7D9",
    quantity: 0,
    discount: 10,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "lowest", // Added sorting key
    featuredImage:
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    images: [
      "https://www.martinguitar.com/dw/image/v2/BGJT_PRD/on/demandware.static/-/Library-Sites-MartinSharedLibrary/default/dw53fd4052/images/blog/102023-tone-woods/blog-top-woods-3.jpg",
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "amplifier"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e0",
    name: "Acoustic Guitar",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 1200,
    salesPrice: 1000,
    stock: 6,
    sold: 3,
    rating: 4.7,
    sku: "GUI-ACOU-006-C7E0",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "latest", // Added sorting key
    featuredImage:
      "https://www.martinguitar.com/dw/image/v2/BGJT_PRD/on/demandware.static/-/Library-Sites-MartinSharedLibrary/default/dw53fd4052/images/blog/102023-tone-woods/blog-top-woods-3.jpg",
    images: [
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f7",
      name: "Guitar",
      slug: "guitar",
    },
    tags: ["guitar", "acoustic"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e1",
    name: "Guitar Strings Set",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 250,
    salesPrice: 200,
    stock: 25,
    sold: 15,
    rating: 4.6,
    sku: "GUI-STRI-025-C7E1",
    quantity: 0,
    discount: 0,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "highest", // Added sorting key
    featuredImage:
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf9Vf93V6vW8eErI7YopEhG628KECx5XsACQ&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "strings"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e2",
    name: "Guitar Pickguard",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 350,
    salesPrice: 300,
    stock: 18,
    sold: 7,
    rating: 4.5,
    sku: "GUI-PICK-018-C7E2",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "lowest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf9Vf93V6vW8eErI7YopEhG628KECx5XsACQ&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbmqSPofxHbLIvXM-uhTie2APSUYqJNvJWrg&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "pickguard"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e3",
    name: "Bass Guitar",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 1800,
    salesPrice: 1600,
    stock: 4,
    sold: 2,
    rating: 4.9,
    sku: "GUI-BASS-004-C7E3",
    quantity: 0,
    discount: 12,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "latest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf9Vf93V6vW8eErI7YopEhG628KECx5XsACQ&s",
    images: [
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f7",
      name: "Guitar",
      slug: "guitar",
    },
    tags: ["guitar", "bass"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e4",
    name: "Guitar Pedal",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 650,
    salesPrice: 550,
    stock: 10,
    sold: 5,
    rating: 4.7,
    sku: "GUI-PEDL-010-C7E4",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "highest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbmqSPofxHbLIvXM-uhTie2APSUYqJNvJWrg&s",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf9Vf93V6vW8eErI7YopEhG628KECx5XsACQ&s",
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "pedal", "effects"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e5",
    name: "Guitar Capo",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 180,
    salesPrice: 150,
    stock: 30,
    sold: 12,
    rating: 3,
    sku: "GUI-CAPO-030-C7E5",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "lowest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSk6hG4l_knffOTNic94x1Y3c82Rju9Tq_kBg&s",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtm6f-aKeWIsv8Q3rkB90x_Vozh2qWjAyJ6g&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "capo"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e6",
    name: "Guitar Tuner",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 200,
    salesPrice: 180,
    stock: 20,
    sold: 8,
    rating: 4.5,
    sku: "GUI-TUNE-020-C7E6",
    quantity: 0,
    discount: 18,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "latest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtm6f-aKeWIsv8Q3rkB90x_Vozh2qWjAyJ6g&s",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSk6hG4l_knffOTNic94x1Y3c82Rju9Tq_kBg&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQS8QjbYMtgZr3KeWO0KccWMESJROF_5_Rkg&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "tuner"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e7",
    name: "Guitar Strap",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 280,
    salesPrice: 240,
    stock: 15,
    sold: 6,
    rating: 4.4,
    sku: "GUI-STRA-015-C7E7",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: false,
    onSale: true,
    sorting: "highest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQS8QjbYMtgZr3KeWO0KccWMESJROF_5_Rkg&s",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf9Vf93V6vW8eErI7YopEhG628KECx5XsACQ&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbmqSPofxHbLIvXM-uhTie2APSUYqJNvJWrg&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "strap"],
  },
  {
    id: "67cb7ca991fb8a62d2e6c7e8",
    name: "Guitar Case",
    description:
      "Pickguard made to fit Bass VI models offered by Fender and Squier that have been modified to feature Triple humbucker pickups. 1/16th Aluminum - Countersunk holes - Durable black powder coat finish",
    price: 750,
    salesPrice: 650,
    stock: 8,
    sold: 3,
    rating: 2,
    sku: "GUI-CASE-008-C7E8",
    quantity: 0,
    discount: 15,
    discountType: "percentage",
    isFeatured: true,
    onSale: true,
    sorting: "lowest", // Added sorting key
    featuredImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrXRjhIOV3cDzip0DoMvIWWiaJzm30VVyYJg&s",
    images: [
      "https://stuff.fendergarage.com/images/N/Q/W/tune-acoustic-2up-1176x660.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVeCOFJt4famiMc0LNtAiXEdC696cI_ehGhw&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwTlXTW8_1Mrv-gOTjTrrws4xQqQTUD_iTrg&s",
      "https://www.lamusic.com/cdn/shop/products/K64638000000000-00-500x500_500x500.jpg?v=1702398292",
    ],
    category: {
      id: "67c72d4d8189fd88440078f8",
      name: "Accessories",
      slug: "accessories",
    },
    tags: ["guitar", "case", "protection"],
  },
];

export const tabContent = {
  features: {
    title: "Features & Specifications",
    // content: "Features & Specifications content goes here...",
    content: [
      "Embodying the raw, wayward spirit of rock 'n' roll, the Kilburn portable active stereo speaker takes the unmistakable look and sound of Marshall, unplugs the chords, and takes the show on the road.",
      "Weighing in under 7 pounds, the Kilburn is a lightweight piece of vintage styled engineering. Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound that is both articulate and pronounced. The analogue knobs allow you to fine tune the controls to your personal preferences while the guitar-influenced leather strap enables easy and stylish travel.",
    ],
    images: [
      "https://s3-alpha-sig.figma.com/img/94c3/d5b5/e2eb95f0614e1134814e9b29d92e136b?Expires=1743379200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=mZL9idJy2qUYjJh5kaPnTnmb27q7VqVJE2lmAe2g4I~AwgUvV-1r1jQd24hm7k97Ep1z07wXYhFCssns5itAmtPY9Ed0GW0Vwb6LEvd6oLTAP1vZqcJj5ptBFoPj4Njj0E3TYruj1j7LESK509IcSipkP6c6wQSh-4AYDE23Q8RkotbFHH4NoApXbWQtABV8dAV77YOy9is23kdZ4oxlVD1s1qK3Kb7rCM~iM-i4iHZDVdXu1SxaT4rq8Id9NHZ0w6gA1hSq491-SDTngxlCyqjaMVcn0pR2nmxGqWOgbQrldjGo9HIMfDTQzYKM1MV0uSRrfZzDALbxhQ5JJKT-Bg__",
      "https://s3-alpha-sig.figma.com/img/11ab/7e59/0ae5342b04326d58d110e32323ea4924?Expires=1743379200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=RrzPSwA-BeodTBWiv2tGY8YObAccwM7WOC94Xir73-3t0HY-E7AEXjxNMvhgn6QVLhvBX22liF38v9U17NlvhINpufft8wnWWv6Qj6mPk--SnMUlP7VTxD3t40TxhWjhwoLIr4gjgvjTmK6it7VRGb7L6x2K-brgzbdhzZ2syZZN1dtT0ipAljLveK-OjJR0VOMK0CwS2GRWVO~FArYchwEHxJMhFjre9GOH0wTiXng1fcxMhQlnD1GgJP5KvT37ZTVaQzMca~1CSxQ6umcVqPkbrcs3~LYXzMR0~xFSbSJjOGjtMlZaDecBPxa58xo25F4IzkLCUC4UOLfkgzJOxA__",
    ],
  },
  additional: {
    title: "Additional Information",
    content: [
      "Embodying the raw, wayward spirit of rock 'n' roll, the Kilburn portable active stereo speaker takes the unmistakable look and sound of Marshall, unplugs the chords, and takes the show on the road.",
      "Weighing in under 7 pounds, the Kilburn is a lightweight piece of vintage styled engineering. Setting the bar as one of the loudest speakers in its class, the Kilburn is a compact, stout-hearted hero with a well-balanced audio which boasts a clear midrange and extended highs for a sound that is both articulate and pronounced. The analogue knobs allow you to fine tune the controls to your personal preferences while the guitar-influenced leather strap enables easy and stylish travel.",
    ],
    images: [
      "https://s3-alpha-sig.figma.com/img/94c3/d5b5/e2eb95f0614e1134814e9b29d92e136b?Expires=1743379200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=mZL9idJy2qUYjJh5kaPnTnmb27q7VqVJE2lmAe2g4I~AwgUvV-1r1jQd24hm7k97Ep1z07wXYhFCssns5itAmtPY9Ed0GW0Vwb6LEvd6oLTAP1vZqcJj5ptBFoPj4Njj0E3TYruj1j7LESK509IcSipkP6c6wQSh-4AYDE23Q8RkotbFHH4NoApXbWQtABV8dAV77YOy9is23kdZ4oxlVD1s1qK3Kb7rCM~iM-i4iHZDVdXu1SxaT4rq8Id9NHZ0w6gA1hSq491-SDTngxlCyqjaMVcn0pR2nmxGqWOgbQrldjGo9HIMfDTQzYKM1MV0uSRrfZzDALbxhQ5JJKT-Bg__",
      "https://s3-alpha-sig.figma.com/img/11ab/7e59/0ae5342b04326d58d110e32323ea4924?Expires=1743379200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=RrzPSwA-BeodTBWiv2tGY8YObAccwM7WOC94Xir73-3t0HY-E7AEXjxNMvhgn6QVLhvBX22liF38v9U17NlvhINpufft8wnWWv6Qj6mPk--SnMUlP7VTxD3t40TxhWjhwoLIr4gjgvjTmK6it7VRGb7L6x2K-brgzbdhzZ2syZZN1dtT0ipAljLveK-OjJR0VOMK0CwS2GRWVO~FArYchwEHxJMhFjre9GOH0wTiXng1fcxMhQlnD1GgJP5KvT37ZTVaQzMca~1CSxQ6umcVqPkbrcs3~LYXzMR0~xFSbSJjOGjtMlZaDecBPxa58xo25F4IzkLCUC4UOLfkgzJOxA__",
    ],
  },
};

// Service Page

export const orderGuidePagebannerData: BannerData = {
  img: allImagesPath.jumpingMen,
  smHeading: "We are the best",
  lgHeading: "Bring Your Ideas to Life!",
  paragraph: "Upload your Print and Drill Templates and get high-quality custom products quickly and easily.",
  btnText: "Get Started Now",
  isheadLine: true,
};

export const resoucesContactData: BannerData = {
  img: allImagesPath.jumpingMen,
  smHeading: "Still Have Questions? Let’s Talk!",
  lgHeading: "Need More Help? Contact Us",
  details: `If you need additional support, we’re here to help. Reach out to our team for personalized guidance, custom design requests, and order assistance.`,
  supportTitle: "Reach us directly for quick assistance.",
  supportText: "Contact our team now!",
  helpText: "Contact our team now!",
  btnText: "Contact Us",
  isheadLine: true,
};


export const faqArray = [

  {
    question: "When Can I Expect My Guitar Neck Order?",
    answer:
      "We accept high-resolution files in PDF, AI, EPS, PSD, and TIFF formats. For best results, please ensure all text is converted to outlines and images are at least 300 DPI.",
    isOpen: true,
  },
  {
    question: "What Is Your Shipping Policy?",
    answer:
      `All parts will be sent via UPS. I will ship other methods, however, please contact me first.

Canadian and Everywhere Else Customers, your packages are also mailed within 4-6 weeks. Please note that if your package is held up in customs the duration of your delivery will take longer. International buyers are solely responsible for any and all duties or taxes.

We are not responsible for lost or stolen merchandise through the shipping process unless additional shipping insurance has been purchased by the buyer. Please contact us for rates. (But if this does happen we will try our best to make things right!)`,
    isOpen: false,
  },
  {
    question: "Repairs And Returns?",
    answer:
      `You have up to 30 days to report any defect or breakage in a part. Please contact me in case this occurs. If the piece is faulty or damaged from my own error, I will fix the piece at no cost to you. If the damage was an accident on your end, the repair cost is dependent on the part in need of replacing or repair. Regardless, I will try to fix any damaged pieces.

If you are not happy for any reason, please contact me and I will try to make it right!

(I do, however, give descriptions of each part and list materials and dimensions with each item along with photos.)

Once your item is delivered you must contact me within 10 days for a return or refund.

Custom orders are not returnable.`,
    isOpen: false,
  },
  {
    question: "What Guitars Do Your Necks Fit?",
    answer:
      `**S25516 Style (Standard Nut Style)**

These necks are designed with the intention to fit 4 bolt Fender Telecaster, Stratocaster and Jazzmaster neck pockets. Non Fender bodies, non 25.5 scale Fenders guitars or 3-bolt neck joint may not be compatible without modification to one or more components.

**Important:** The only way to be sure of proper fitment is to measure your guitar.

**Specifications:**
• Width = 2-3/16" (56 mm)
• Length = 3" (76 mm)
• Pocket Depth = 5/8" (16 mm)

**FR25516 Style (Floyd Rose Style)**

Designed with the intention to fit 25.5" scale 4 bolt Fender Stratocasters and other guitars made with a Fender spec neck pocket equipped with a Floyd Rose Tremelo System. Non Fender bodies, non 25.5 scale Fenders guitars or 3-bolt neck joint may not be compatible without modification to one or more components.

**Important:** The only way to be sure of proper fitment is to measure your guitar.

**Specifications:**
• Width = 2-3/16" (56 mm)
• Length = 3" (76 mm)
• Pocket Depth = 5/8" (16 mm)`,
    isOpen: false,
  },
];
